import { ref } from "vue";

const isDragging = ref(false);

export function useDragState() {
    function startDragging() {
        setTimeout(() => {
            isDragging.value = true;
        }, 0);
    }

    function resetDragState() {
        isDragging.value = false;
    }

    return {
        isDragging,
        startDragging,
        resetDragState,
    };
}
